<template lang="pug">
h2 you should never see this
</template>

<script>


export default {
  name: 'SettingsSlackCallback',
  mounted () {
    console.log('here------')
    console.log(this.$route)
    if (this.$route.query.code) {
      this.getSlackCode()
    } else {
      this.close({
        data: 'auth_failure',
        errorMsg: 'Ooooops'
      })
    }
  },
  methods: {
    getSlackCode () {
      this.$axios.get(`/integration/slack/callback?code=${this.$route.query.code}`)
        .then(result => {

          if(result.data.error){
            this.close({
              data: 'auth_failure',
              errorMsg: result.data.error
            })
          }
          if(result.data.url){
            this.close({
              data: 'auth_success'
            })
          }
          parent.close()
        })
        .catch(function(e){
          console.log(e)
          this.close({
            data: 'auth_failure',
            errorMsg: e
          })
        })
    },
    close (data) {
      window.opener.postMessage(data, '*')
      parent.close()      
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
